import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { VersionRendererComponent } from '@shared/components/version-renderer/version-renderer.component';

@Component({
  selector: 'fb-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, VersionRendererComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
